import { render, staticRenderFns } from "./property.vue?vue&type=template&id=64fceea6&scoped=true"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"
import style0 from "./property.vue?vue&type=style&index=0&id=64fceea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fceea6",
  null
  
)

export default component.exports